import { render, staticRenderFns } from "./BlackLists.vue?vue&type=template&id=5a2021d2&"
import script from "./BlackLists.vue?vue&type=script&lang=ts&"
export * from "./BlackLists.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports